// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__30RYU","additionalInfo":"AgreementModal_additionalInfo__21eFy"};